import {
  beCampaignsBuilderGetArrayOfListsByIdSource,
  beCampaignsBuilderGetArrayOfSourcesByIdList,
  beCampaignsBuilderGetCampaignsByIdSource,
  beCampaignsSetArrayOfListsByIdSource
} from 'Api/beCampaign'
import { beContentProviderGetListOfContents } from 'Api/beContentProvider'
import {
  beContentSourceGetListOfSources,
  beContentSourceGetListOfStatus,
  beContentSourceDeleteSource
} from 'Api/beContentSource'
import { beListGetUserLists, beListGetListOfNlList } from 'Api/beListApi'

export async function getListOfSources(params) {
  const result = await beContentSourceGetListOfSources(params)
  return result
}

export async function getListOfStatus(idSource) {
  const params = { pageSize: 1, pageNumber: 1 }
  const result = await beContentSourceGetListOfStatus(idSource, params)
  return result
}

export async function getListOfContents(idSource) {
  const params = { pageSize: 1, pageNumber: 1 }
  const result = await beContentProviderGetListOfContents(idSource, params)
  return result
}

export async function getArrayOfListsByIdSource(idSource) {
  const result = await beCampaignsBuilderGetArrayOfListsByIdSource(idSource)
  return result
}

export async function getUserLists() {
  const result = await beListGetUserLists()
  return result
}

export async function getArrayOfSourcesByIdList(idList) {
  const result = await beCampaignsBuilderGetArrayOfSourcesByIdList(idList)
  return result
}

export async function deleteSource(idSource) {
  const result = await beContentSourceDeleteSource(idSource)
  return result
}

export async function getCampaignsByIdSource(idSource) {
  const result = await beCampaignsBuilderGetCampaignsByIdSource(idSource)
  return result
}

export async function getTargetLists(idList, idSource) {
  const { Items } = await beListGetListOfNlList({
    force: true,
    pageSize: 0,
    pageNumber: 0,
    orderBy: 'Id',
    orderDescending: false
  })

  let { Items: campaigns } =
    await beCampaignsBuilderGetCampaignsByIdSource(idSource)
  campaigns = campaigns.map(({ IdList }) => IdList)

  return Items.map(({ IdList, Name }, index) => ({
    value: IdList,
    label: `${IdList} - ${Name}`,
    disabled: campaigns.includes(IdList)
  }))
}

export async function setArrayOfListsByIdSource(idSource, data) {
  const result = await beCampaignsSetArrayOfListsByIdSource(idSource, {
    ArrayOfListId: data
  })
  return result
}
